export const IndexSearchParams = {
  DELETED_WORKFLOW: 'deletedWorkflow'
};